import React from 'react';
import ReactApexChart from 'react-apexcharts';

const CandlestickChart = ({ data, height = 200 }) => {
    // Format data for ApexCharts - use displayTime for X-axis
    const chartData = data.map(item => ({
        x: item.displayTime, // Use the minute string directly (e.g., "05")
        y: [item.open, item.high, item.low, item.close],
        fullTime: item.fullTime // Keep full time for tooltips
    }));

    const options = {
        chart: {
            type: 'candlestick',
            height: height,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            },
            animations: {
                enabled: true,
                easing: 'linear',
                speed: 300,
            }
        },
        title: {
            text: '',
            align: 'left'
        },
        xaxis: {
            type: 'category', // Change from 'datetime' to 'category'
            categories: data.map(item => item.displayTime), // Use minute strings directly
            labels: {
                style: {
                    colors: '#666666',
                    fontSize: '10px'
                },
                // No formatter needed since we're using pre-formatted minutes
            },
            axisBorder: {
                show: true,
                color: '#f0f0f0'
            },
            axisTicks: {
                show: true,
                color: '#f0f0f0'
            }
        },
        yaxis: {
            tooltip: {
                enabled: true
            },
            labels: {
                style: {
                    colors: '#666666',
                    fontSize: '10px'
                },
                formatter: (value) => `$${value.toFixed(0)}`
            }
        },
        grid: {
            borderColor: '#f0f0f0',
            strokeDashArray: 3,
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            }
        },
        plotOptions: {
            candlestick: {
                colors: {
                    upward: '#26a69a',
                    downward: '#ef5350'
                },
                wick: {
                    useFillColor: true,
                }
            }
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
            custom: function ({ seriesIndex, dataPointIndex, w }) {
                const dataPoint = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
                const o = dataPoint.y[0];
                const h = dataPoint.y[1];
                const l = dataPoint.y[2];
                const c = dataPoint.y[3];
                const fullTime = dataPoint.fullTime; // Use the stored full time

                return (
                    '<div class="apexcharts-tooltip-candlestick bg-dark text-white p-2 rounded">' +
                    `<div class="small mb-1">Time: ${fullTime}</div>` +
                    `<div class="small mb-1">Open: <span class="value">$${o}</span></div>` +
                    `<div class="small mb-1">High: <span class="value">$${h}</span></div>` +
                    `<div class="small mb-1">Low: <span class="value">$${l}</span></div>` +
                    `<div class="small mb-0">Close: <span class="value">$${c}</span></div>` +
                    '</div>'
                );
            }
        }
    };

    const series = [{
        data: chartData
    }];

    return (
        <ReactApexChart
            options={options}
            series={series}
            type="candlestick"
            height={height}
        />
    );
};

export default CandlestickChart;